var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_files",
            "show-buttons": false,
            title: "Vertragsdokumente",
          },
        },
        [
          _c("csp-firm-files", {
            attrs: { editable: "", "firm-id": _vm.firmId },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }